// Libs
import React, { Component } from 'react'
import { Container } from '../../components/Elemental'
import { connect } from 'react-redux'

// CSS
import './styles.scss'

// Components/Containers
import CloseIcon from '../../components/CloseIcon'

// Actions
import { changeAlertVisible, changeAlertType, changeAlertText } from './actions'

// Env
import env from '../../env'

class Alert extends Component {
  UNSAFE_componentWillMount() {
    const { text, changeAlertVisible } = this.props
    const { requestPermission } = this

    if ('Notification' in window) {
      const permission = window.Notification.permission

      if (permission === 'default') {
        const randomArray = [0, 1]

        const randomNumber = Math.floor(Math.random() * randomArray.length)

        // if(randomNumber === 0) changeAlertVisible(true)
        if (randomNumber === 0) requestPermission('automatic')
        if (randomNumber === 1) requestPermission('automatic')
      }
    }
  }

  requestPermission = (comeFrom) => {
    const { text } = this.props

    try {
      window.Notification.requestPermission()
        .then(result => {
          const { changeAlertVisible } = this.props

          changeAlertVisible(false)
        })
    } catch (error) {
      // Safari doesn't return a promise for requestPermissions and it
      // throws a TypeError. It takes a callback as the first argument
      // instead.
      if (error instanceof TypeError) {
        const { changeAlertVisible } = this.props

        changeAlertVisible(false)
      } else {
        throw error;
      }
    }
  }

  close = (e) => {
    const { text, changeAlertVisible } = this.props

    changeAlertVisible(false)
    e.stopPropagation()
  }

  render() {
    const { visible, type, text } = this.props
    const { requestPermission, close } = this

    return (
      <div className={visible ? "alert alert--visible" : "alert"} onClick={() => requestPermission('click')}>
        <Container className="alert__container">
          <p dangerouslySetInnerHTML={{ __html: text }} />
          <div className="alert__close">
            <CloseIcon width={16} color="white" onClick={close} />
          </div>
        </Container>
      </div>
    )
  }
}

Alert = connect(state => ({
  visible: state.alert.visible,
  type: state.alert.type,
  text: state.alert.text,
}), { changeAlertVisible, changeAlertType, changeAlertText })(Alert)

export default Alert
